module.exports = "<div class=\"bchx {{state}}\" [ngClass]=\"{'checked' : this.state==true, '': this.state==false}\"></div> ";